import { Box, HStack, Text, Image } from '@chakra-ui/react';
import { Handle, Position } from 'reactflow';

import EndNodeIcon from '../../../../assets/projects/end.svg';
import { END_NODE_WIDTH, NODE_SIZE } from '../../../../constants';

export const EndNode = () => {
  return (
    <Box bg="white">
      <Handle
        type="target"
        position={Position.Top}
        id="b"
        style={{ width: NODE_SIZE, height: NODE_SIZE }}
      />

      <HStack
        justify="center"
        border="1px"
        borderColor="red"
        borderRadius="md"
        w={`${END_NODE_WIDTH}px`}
        h="8"
      >
        <Text fontSize="xs" fontWeight="medium">
          End
        </Text>

        <Image src={EndNodeIcon} />
      </HStack>
    </Box>
  );
};
